import React, { HTMLAttributes, useMemo } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import store from "store";

import styles from "./index.module.scss";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className, ...rest }) => {
  const t = useTranslation();
  const { name } = store.market;
  const { leverAccountOverview } = store.balances;

  const valueLabel = useMemo(() => {
    const unit = name.split("_")[1].toUpperCase();
    return (leverAccountOverview ? leverAccountOverview.liquidationPrice : "--") + " " + unit;
  }, [leverAccountOverview, name]);

  return (
    <div className={cx(styles.main, className)} {...rest}>
      <div>
        <span>{t("trade.liqPrice")}</span>:
      </div>
      <div>{valueLabel}</div>
    </div>
  );
};

export default observer(Main);
// export default Main;
